import ArrowButton from '@/components/molecules/arrowButton'
import ResponsiveTitle from '@/components/molecules/responsiveTitle'
import Container from '@/components/templates/container'
import EventContainer from './container'
import Spacer from '@/components/atoms/spacer'

const Events = ({ events }) => {
  return (
    <Container outerClassName="mt-largeMobile lg:mt-largeDesktop">
      <div className="relative w-full mb-largeMobile lg:largeDesktop">
        <ResponsiveTitle left={events.title.left} right={events.title.right} className='max-w-[232px] mx-auto md:max-w-none' />
        <EventContainer events={events.highlights} />
        <ArrowButton
          name="Discover All"
          link="/events"
          className="mx-auto mt-smallMobile md:mt-mediumDesktop"
        />
      </div>
      <Spacer />
    </Container>
  )
}

export default Events
